import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { loadCategoryEvents, loadTimesEvents } from '../actions';
import FestivalScheduleMobileCategoryEvents from '../components/festival/schedule/FestivalScheduleMobileCategoryEvents';
import FestivalScheduleMobileTimesEvents from '../components/festival/schedule/FestivalScheduleMobileTimesEvents';
import FestivalScheduleMobileNav from '../components/festival/schedule/FestivalScheduleMobileNav';

class FestivalSchedule extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    showView: 'timesEvents'
  }

  componentWillMount() {

    if (this.props.browser.lessThan.desktop) {
      this.props.loadCategoryEvents();
      this.props.loadTimesEvents();
    }
  }

  componentWillReceiveProps(nextProps) {
    let isSame = (
      this.props.browser.width == nextProps.browser.width
    );
    if (!isSame) {
      if (this.props.browser.lessThan.desktop) {
        this.props.loadCategoryEvents();
        this.props.loadTimesEvents();
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  setScheduleView = (action) => {
    this.setState({showView: action})
  }

  render() {

    let scheduleView = '';

    if (this.state.showView == 'categoriesEvents') {
      scheduleView = <div className="festivalSchedule-mobileScheduleWrapper">
        <FestivalScheduleMobileCategoryEvents
          girlsFestivalCategoryEvents = {this.props.girlsFestivalCategoryEvents}
        />
      </div>;
    } else {
      scheduleView = <div className="festivalSchedule-mobileScheduleWrapper">
        <FestivalScheduleMobileTimesEvents
          girlsFestivalTimesEvents = {this.props.girlsFestivalTimesEvents}
        />
      </div>
    }

    return(
      <div>
        <div className="festivalHome-bannerWrapper">
          <Link to="/girls-festival/tickets"><img className="desktop" src="/images/festival/home/gf_homepage_banner_desktop_post.jpg" /></Link>

          <Link to="/girls-festival/tickets"><img className="mobile" src="/images/festival/home/gf_homepage_banner_mobile_post.jpg" /></Link>
        </div>

        <div className="content-wrapper">

        <div className="headerTagWrapper">
          <h1 className="page-heading">It was an action-packed day -- take a look!</h1>


        </div>

          <FestivalScheduleMobileNav setScheduleView = {this.setScheduleView} />

          {scheduleView}


          <div className="festivalSchedule-desktopScheduleWrapper">
            <div style={{ overflow: 'hidden', width: '1140px', margin: '4.0rem auto 6.0rem auto' }} className="festivalSchedule-iframeWrapper">
              <iframe width="1140" height="734" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vSRSay320yXVTPu7WULZew8SepZHZ5_lyzmiY9z0szmw_mbYTBjgn8_ooZAVInzqoBRkhqx7E08XsYC/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"></iframe>
            </div>

            <div style={{ overflow: 'hidden', width: '1040px', margin: '0 auto 6.0rem auto' }} className="festivalSchedule-iframeWrapper">
              <iframe width="1040" height="784" src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTJUkvruvcRY_mbYZfy3yMhRGPf_Zo_bCoy9nMqaXKIoxJTLDp-WJuZPdiyflBiV8mGmu-EPqhee3vn/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"></iframe>
            </div>
          </div>

        </div>{/* End content-wrapper */}


      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    Link,
    push,
    loadCategoryEvents,
    loadTimesEvents
  }
)(FestivalSchedule);



// WEBPACK FOOTER //
// ./src/containers/FestivalSchedule.jsx